import { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

const ModalExtras = ({ producto, extrasSeleccionados, onGuardar, onCerrar }) => {
    const [seleccionados, setSeleccionados] = useState(extrasSeleccionados || []);

    const handleToggle = (extra) => {
        const existe = seleccionados.find(e => e.nombre === extra.nombre);
        if (existe) {
            setSeleccionados(prev => prev.filter(e => e.nombre !== extra.nombre));
        } else {
            setSeleccionados(prev => [...prev, extra]);
        }
    };

    const totalExtras = seleccionados.reduce((acc, e) => acc + e.precio, 0);

    return (
        <>
            <style>{`
                .modal-extras .modal-content {
                    background: #1A1A1A;
                    border: 1px solid #2E2E2E;
                    border-radius: 16px;
                }
                .modal-extras .modal-header {
                    border-bottom: 1px solid #2E2E2E;
                    padding: 1.1rem 1.5rem;
                }
                .modal-extras .modal-footer {
                    border-top: 1px solid #2E2E2E;
                    padding: 1rem 1.5rem;
                }
                .modal-extras .modal-title {
                    color: #F0F0F0;
                    font-weight: 700;
                }
                .modal-extras .btn-close {
                    filter: invert(1) brightness(0.6);
                }
                .extra-item {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 0.9rem 0;
                    border-bottom: 1px solid #222;
                    cursor: pointer;
                    user-select: none;
                }
                .extra-item:last-child { border-bottom: none; }
                .extra-check {
                    width: 26px; height: 26px;
                    border-radius: 7px;
                    border: 2px solid #444;
                    display: flex; align-items: center; justify-content: center;
                    flex-shrink: 0;
                    transition: all 0.15s;
                }
                .extra-check.checked {
                    background: #F5C800;
                    border-color: #F5C800;
                }
            `}</style>

            <Modal show={true} onHide={onCerrar} centered dialogClassName="modal-extras">
                <Modal.Header closeButton>
                    <Modal.Title>
                        <i className="fas fa-plus-circle me-2" style={{ color: '#F5C800' }}></i>
                        Extras — {producto.nombre}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ padding: '0.5rem 1.5rem' }}>
                    {producto.extras.map((extra, idx) => {
                        const activo = !!seleccionados.find(e => e.nombre === extra.nombre);
                        return (
                            <div key={idx} className="extra-item" onClick={() => handleToggle(extra)}>
                                <div className="d-flex align-items-center gap-3">
                                    <div className={`extra-check${activo ? ' checked' : ''}`}>
                                        {activo && <i className="fas fa-check" style={{ color: '#111', fontSize: '0.75rem' }}></i>}
                                    </div>
                                    <span style={{ color: activo ? '#F0F0F0' : '#888', fontWeight: 500, fontSize: '1rem' }}>
                                        {extra.nombre}
                                    </span>
                                </div>
                                <span style={{ color: '#F5C800', fontWeight: 600, fontSize: '0.95rem' }}>
                                    +${extra.precio.toFixed(2)}
                                </span>
                            </div>
                        );
                    })}
                </Modal.Body>

                <Modal.Footer className="d-flex justify-content-between align-items-center">
                    <span style={{ color: '#888', fontSize: '0.9rem' }}>
                        {seleccionados.length > 0 && (
                            <span style={{ color: '#F5C800', fontWeight: 600 }}>
                                +${totalExtras.toFixed(2)} en extras
                            </span>
                        )}
                    </span>
                    <div className="d-flex gap-2">
                        <Button variant="outline-secondary" onClick={onCerrar}
                            style={{ borderColor: '#2E2E2E', color: '#888', background: 'transparent' }}>
                            Cancelar
                        </Button>
                        <Button onClick={() => onGuardar(seleccionados)}
                            style={{ background: '#F5C800', border: 'none', color: '#111', fontWeight: 700 }}>
                            Guardar
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ModalExtras;
